// client/src/pages/DashboardPage.js
import { Navigate } from 'react-router-dom';
import { useDashboardData } from '../hooks/useDashboardData';

import AdministrationDashboardPage from './AdministrationDashboardPage';
import PreProductionDashboardPage from './PreProductionDashboardPage';
import ManufacturingDashboardPage from './ManufacturingDashboardPage';
import ShippingDashboardPage from './ShippingDashboardPage';
import EmployeeDashboardPage from './EmployeeDashboardPage';
import SupervisorDashboardPage from './SupervisorDashboardPage'

export default function DashboardPage() {
  const { user } = useDashboardData();

  // Not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Route by role
  switch (user.role) {
    case 'Admin':
      return <AdministrationDashboardPage />;

    case 'PreProduction':
      return <PreProductionDashboardPage />;

    case 'Manufacturing':
      return <ManufacturingDashboardPage />;

    case 'Shipping':
      return <ShippingDashboardPage />;

    case 'Employee':
      return <EmployeeDashboardPage />;

    case 'Supervisor':
      return <SupervisorDashboardPage />;

    case 'Dealer':
      return <Navigate to="/dealer-dashboard" replace />;

    default:
      return <Navigate to="/login" replace />;
  }
}
